import { render } from "./search-start.vue?vue&type=template&id=336d451a"
import script from "./search-start.vue?vue&type=script&lang=js"
export * from "./search-start.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__